<!--  -->
<template>
  <div class="Notification">
    <van-popup :close-on-click-overlay="false" v-model="show">
      <div class="Modal">
        <div class="title">
          <span>提示</span>
        </div>
        <div class="content">
          <div class="contentText">{{title}}</div>
          <div class="footer">
            <div class="itOut" @click="goMyloan">去查看</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Notification',
  data() {
    return {
      show: false,
    };
  },
  props: ['isShow', 'title', 'activeIndex'],
  watch: {
    isShow: {
      handler(val) {
        this.show = val;
      },
      immediate: true,
    },
  },
  methods: {
    goMyloan() {
      // this.jumpTheThirdPartyAddress(this.orderId)
      this.$router.push('/supermarket/v2/myload?activeIndex='+this.activeIndex);
    },
    jumpTheThirdPartyAddress(orderId) {
      this.$api.PublicPage.jumpCurrPage({
        orderId,
      })
        .then((res) => {
          if (res.success) {
            if (res.data) {
              window.location.href = res.data;
            }
          } else {
            this.$dialog.alert({
              title: '提示',
              message: '操作失败',
            });
          }
        })
        .catch((e) => {
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
        });
    },
  },
};
</script>
<style scoped>
.content {
  width: 303px;
  height: 131px;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.title {
  height: 50px;
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #001f33;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 16px;
  border-bottom: 1px solid#E9F0F5;
}
.van-popup--center {
  border-radius: 10px;
}
.contentText {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #1c2438;
  padding: 12px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close {
  flex: 1;
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #495060;
  border-right: 1px solid #e9eaec;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.itOut {
  width: 90%;
  height: 44px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #fff;
  background: #ff6538;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 12px;
}
</style>
